'use client';



import { useNavigate } from "../../hooks/useNavigate";
import React, { useEffect } from "react";
import branding from "../../assets/collaboration_img.webp";
import { StyledButton } from "../../components/Buttons/StyledButton";
import SecondaryTag from "../../components/Tags/SecondaryTag";
import img1 from "../../assets/numbers/01.svg";
import img2 from "../../assets/numbers/02.svg";
import img3 from "../../assets/numbers/03.svg";
import img4 from "../../assets/numbers/04.svg";
import img from '../../assets/profile.jpg'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import CollaborationForm from "../Forms/CollaborationForm";
import About from "../../components/Apps/DCC/About.jsx";
import purpose from "../../assets/Cutting-Edge Resources.webp";
import skilldevelopment from "../../assets/SkillDevelopment.webp";
import innovativeIdeas from "../../assets/innovative Ideas.webp";
import IndustryExperts from "../../assets/Industry Experts.webp";
import ResearchandDevelopment from "../../assets/Research and Development.webp";
import AlternateImageDetails from "../../components/AlternateImageDetails.jsx";
const testimonials = [
  {
    quote:
      "Our collaboration resulted in a significant 30% increase in student engagement, enhancing the overall learning experience for our students.",
    name: "Dr. Rajesh Patil, Principal, DYPCET",
    img:img
  },
  {
    quote:
      "The faculty development program was truly transformative, equipping our educators with cutting-edge skills and innovative teaching methodologies.",
    name: "Prof. Anjali Deshmukh, Dean of Academics, SGU",
    img:img
  },
  {
    quote:
      "The exceptional support and resources provided have played a pivotal role in advancing our institution's academic and research capabilities.",
    name: "Dr. Vikram Singh, Vice-Chancellor, Shivaji University",
    img:img
  },
  {
    quote:
      "Our students have greatly benefited from the innovative programs, which have prepared them to excel in a competitive global environment.",
    name: "Mr. Sanjay Kumar, Director, TKIET",
    img:img
  },
  {
    quote:
      "The partnership has been instrumental in driving technological advancements and fostering a culture of innovation within our institution.",
    name: "Dr. Meera Sharma, Head of R&D, DYPCET",
    img:img
  },
  {
    quote:
      "The collaborative initiatives have not only improved academic outcomes but also strengthened our institution's reputation in the education sector.",
    name: "Ms. Priya Menon, Academic Coordinator, SGU",
    img:img
  },
];

export const projects = [
  {
    title: "Access to cutting-edge resources",
    description:
      "Stay ahead with the latest tools, technologies, and materials that empower innovation.",
  },
  {
    title: "Opportunities for skill development",
    description:
      "Enhance your capabilities through training, workshops, and hands-on experiences.",
  },
  {
    title: "Exposure to innovative ideas",
    description:
      "Collaborate in environments that encourage creative thinking and pioneering solutions.",
  },
  {
    title: "Networking with industry experts",
    description:
      "Connect with professionals and leaders to grow your industry relationships.",
  },
  {
    title: "Support for research and development",
    description:
      "Receive resources and guidance to advance your R&D initiatives effectively.",
  },
];
const whyPartnersChooseUs = [
  {
    title: "Access to Cutting-Edge Resources",
    content:
      "We provide schools and colleges with advanced tools for HR, CRM, project management, and ERP, all integrated into a single platform.",
    image: purpose,
  },
  {
    title: "Opportunities for Skill Development",
    content: (
      <ul className="space-y-2 my-2 text-color-2">
        <li>
          • Enhance faculty and student skills through structured programs
        </li>
        <li>• Access to industry-relevant training and certifications</li>
        <li>• Stay ahead with up-to-date educational trends and tools</li>
      </ul>
    ),
    image: skilldevelopment,
  },
  {
    title: "Exposure to Innovative Ideas",
    content: (
      <ul className="space-y-2 my-2 text-color-2">
        <li>• Implement modern teaching methodologies</li>
        <li>• Leverage AI-driven insights for better decision-making</li>
        <li>
          • Encourage research-driven learning and project-based education
        </li>
      </ul>
    ),
    image: innovativeIdeas,
  },
  {
    title: "Networking with Industry Experts",
    content: (
      <ul className="space-y-2 my-2 text-color-2">
        <li>• Collaborate with top professionals and educators</li>
        <li>• Get mentorship opportunities for students and faculty</li>
        <li>• Participate in expert-led seminars and workshops</li>
      </ul>
    ),
    image: IndustryExperts,
  },
  {
    title: "Support for Research and Development",
    content: (
      <ul className="space-y-2 my-2 text-color-2">
        <li>• Get funding and guidance for research initiatives</li>
        <li>• Access to premium data analytics and insights</li>
        <li>• Foster a culture of innovation and entrepreneurship</li>
      </ul>
    ),
    image: ResearchandDevelopment,
  },
];

export const Collaboration = () => {
  const navigate = useNavigate();
  // const settings = {
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 2,
  //   slidesToScroll: 1,
  //   adaptiveHeight: true,
  //   draggable: true,
  //   swipeToSlide: true,
  //   touchMove: true,
  //   arrows: false,
  //   appendDots: dots => (
  //     <div style={{ position: 'absolute', top: '-50px', width: '100%' }}>
  //       <ul style={{ margin: '0', padding: '0' }}> {dots} </ul>
  //     </div>
  //   ),
  //   customPaging: i => (
  //     <div className="custom-dot"></div>
  //   ),
  //   responsive: [
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 1,
  //       },
  //     },
  //   ],
  // };
  return (
    <div className="max-w-7xl px-3 sm:px-6 xl:px-10 mx-auto">
      {/* Centera Introduction Section */}
      <header className="flex flex-col sm:flex-row items-center justify-between mb-16 mt-4 sm:mt-[10vh]">
        {/* Left - Title & Subtitle */}
        <div className="flex flex-col gap-4 lg:gap-8">
          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-semibold">
            Collaborate With <br /> Centera Tech
          </h1>
          <p className="font-medium text-lg sm:text-xl lg:text-2xl text-color-2">
            Empowering institutions through <br />
            partnerships & innovative solutions.
          </p>

          {/* CTA Button */}
          <div className="mt-3 mb-5 flex justify-start">
            <StyledButton
              text="Collaboration With Us"
              onClick={() => {
                const section = document.getElementById("collaboration-section");
                if (section) {
                  section.scrollIntoView({ behavior: "smooth" });
                }
              }}
            />
          </div>
        </div>

        {/* Right - Collaboration Image */}
        <div className="relative w-[90%] sm:w-[50%] overflow-hidden rounded-xl">
          {/* Aspect Ratio Box */}
          <div className="relative w-full pb-[56.25%]">
            <div
              className="absolute inset-0 bg-cover bg-top animate-scroll"
              style={{ backgroundImage: `url(${branding})` }}
            ></div>
          </div>
        </div>
      </header>

      {/* Why Partners Choose Us Section */}

      <section>
        <div className="flex flex-col items-center gap-2 lg:mt-28">
          <SecondaryTag
            text="
Feature"
          />
          <h2 className="text-4xl lg:text-[56px] font-medium leading-[normal] lg:mb-16">
            Why Partners Choose Us
          </h2>
        </div>
        <AlternateImageDetails sections={whyPartnersChooseUs} />
      </section>

      {/* Our Collaboration Process Section */}
      <div className="flex flex-col items-center gap-2 lg:mt-28">
        <SecondaryTag text="Process" />
        <div className="w-[300px] md:w-[696px] text-color-1 text-center text-4xl lg:text-[56px] font-medium leading-[normal] lg:mb-16">
          Our Collaboration Process
        </div>
      </div>
      <div className="flex justify-around flex-wrap gap-12 pt-16">
        {[
          {
            img: img1,
            title: "Apply",
            classes: "",
            description: "Submit your application to become our partner",
          },
          {
            img: img2,
            title: "Review",
            classes: "",
            description: "We review your application and finalize agreements.",
          },
          {
            img: img3,
            title: "Onboard",
            classes: "",
            description:
              "Complete the onboarding process with our support team.",
          },
          {
            img: img4,
            title: "Collaborate",
            classes: "",
            description: "Work together on impactful projects and initiatives.",
          },
        ].map((item, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center gap-4 w-52 group relative"
          >
            <div className="absolute -top-10 left-16 rounded-3xl w-[20px] -rotate-45 h-[250px] transition-all duration-700 bg-[radial-gradient(circle,_var(--neutral-bg),_var(--accent-light))] blur-3xl opacity-35 group-hover:opacity-65"></div>
            <img
              src={item.img}
              className={`w-24 h-24 md:w-[85px] md:h-[85px] ${item.classes} transition-all duration-700 opacity-90  md:opacity-60 group-hover:opacity-100 z-10`}
              alt="image"
            />
            <h3 className="text-color-1 text-4xl font-semibold -mt-7 z-20">
              {item.title}
            </h3>
            <p className="text-color-2">{item.description}</p>
          </div>
        ))}
      </div>

      {/* Testimonial Section */}
      <section className="mt-10">
        <div className="flex flex-col items-center gap-2 lg:mt-28">
          <SecondaryTag text="Testimonial" />
          <div className="w-[300px] md:w-[450px] text-color-1 text-center text-4xl lg:text-[56px] font-medium leading-[normal] lg:mb-16">
            The Impact Of Our Partnerships
          </div>
        </div>
        {/* Carousel */}
        <Swiper
      className="mt-16 lg:mt-2"
      slidesPerView={1}
      spaceBetween={20}
      loop={true}
      autoplay={{
        delay: 4000,
        disableOnInteraction: false,
      }}
      pagination={{
        clickable: true,
        dynamicBullets: true,
      }}
      modules={[Pagination, Autoplay]}
      breakpoints={{
        600: { slidesPerView: 2 },
      }}
    >
      {testimonials.map((item, index) => (
        <SwiperSlide key={index} className="mt-5">
          
              <ServiceCard
                rev={index % 2 === 0}
                title={item.quote}
                description={item.name}
                image={item.img}
              />
          
        </SwiperSlide>
      ))}
    </Swiper>
     
      </section>

      {/* Partnerships Metrics Section */}
      <section className="mt-10">
        <div className="flex flex-col items-center gap-2 lg:mt-28">
          <SecondaryTag text="Partnerships" />
          <div className="w-[300px] md:w-[450px] text-color-1 text-center text-4xl lg:text-[56px] font-medium leading-[normal] lg:mb-16">
            Building a Better Future Together
          </div>
        </div>

        {/* Collaboration Metrics */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-10">
          {[
            { value: "50+", label: "Partnerships" },
            { value: "699+", label: "Students Impacted" },
            { value: "200+", label: "Faculty Trained" },
            { value: "95%", label: "Satisfaction Rate" },
          ].map((item, index) => (
            <div key={index} className="text-center">
              <p className="text-4xl font-bold text-color-1">{item.value}</p>
              <p className="text-lg text-color-2">{item.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Collaboration Request Section */}
      <section id="collaboration-section" className="mt-10">
        <div className="flex flex-col items-center gap-2 lg:mt-28">
          <SecondaryTag text="Shaping Talent" />
          <div className="w-[300px] md:w-[796px] text-color-1 text-center text-4xl lg:text-[56px] font-medium leading-[normal] lg:mb-16">
            Collaboration Request
          </div>
        </div>
        <CollaborationForm />
      </section>
    </div>
  );
};

export default Collaboration;

const ServiceCard = ({ rev, title, description, image, compact }) => {
  const [isLargeScreen, setIsLargeScreen] = React.useState(
    window.innerWidth >= 1024
  );

  React.useEffect(() => {
    const handleResize = () => setIsLargeScreen(window.innerWidth >= 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="relative h-full p-px rounded-xl w-full overflow-hidden cursor-pointer group">
      <div
        className={`absolute inset-0 rounded-xl bg-[linear-gradient(155deg,var(--accent-light),var(--secondary-bg)_80%)] transition-transform duration-700 group-hover:rotate-180 blur-3xl scale-150`}
      ></div>
      <div
        className={`lg:h-52 ${
          compact ? "2xl:h-[250px]" : "2xl:h-[230px]"
        } flex flex-col lg:flex-row overflow-hidden items-center lg:items-stretch gap-0 lg:gap-6 rounded-xl bg-[var(--secondary-bg)] backdrop-blur-[7px] shadow-lg`}
      >
        <div
          className="w-full lg:w-[40%] h-40 lg:h-full scale-125 md:scale-150 lg:scale-125 group-hover:scale-110 transition-all duration-700"
          style={
            isLargeScreen
              ? {
                  clipPath: "polygon(0 0, 80% 0, 100% 100%, 0% 100%)",
                }
              : {
                  clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 70%)",
                }
          }
        >
          <img
            loading="lazy"
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-125 transition-all duration-700 md:grayscale-[70%] group-hover:grayscale-[0%]"
          />
        </div>

        {/* Content Section */}
        <div className="w-full lg:w-[60%] relative flex flex-col justify-center p-3 md:p-6 ">
          <div className="z-10 flex flex-col items-start gap-3">
            <p className="text-color-1 font-semibold mt-3">
              &quot; {title} &quot;
            </p>
            <div className="text-color-2">{description}</div>
          </div>
          <div className="flex flex-col lg:items-end gap-4 mt-4">
          </div>
        </div>
        <div
          className="absolute top-5 right-5 -rotate-45 w-[300px] h-[100px] bg-[radial-gradient(circle,_var(--accent-dark),_var(--accent-dark))] blur-3xl opacity-20 group-hover:opacity-35 transition-all duration-700"
        ></div>
      </div>
    </div>
  );
};

